import React from "react";
import { motion } from "framer-motion";
import Section from "./Section";

const outcomes = [
  {
    q: "Guest waiting time collapsed across peak arrival windows — the front desk stopped being the bottleneck.",
    a: "Operations Manager",
    role: "Luxury Hotel Apartment",
  },
  {
    q: "For the first time we could see every request, every SLA, every escalation — live. That changed how we run the property.",
    a: "General Manager",
    role: "Boutique Hospitality Group",
  },
  {
    q: "Housekeeping SLA moved from 'we hope so' to 97.9%. That's not a dashboard number. That's a guest-facing outcome.",
    a: "Head of Housekeeping",
    role: "Independent Property",
  },
];

const stats = [
  "Reduced guest waiting time",
  "Improved operational visibility",
  "Faster service delivery",
  "Better staff coordination",
];

export default function Testimonials() {
  return (
    <Section overline="Outcomes" testId="testimonials-section">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-start">
        <div className="md:col-span-5">
          <h2
            className="font-display text-white text-[36px] md:text-[52px] leading-[1.02] tracking-tight text-balance"
            style={{ fontWeight: 800 }}
          >
            What operators actually{" "}
            <span className="grad-text">feel</span> on day 30.
          </h2>
          <div className="mt-8 flex flex-col gap-3">
            {stats.map((s) => (
              <div
                key={s}
                className="flex items-center gap-3 rounded-lg brand-panel px-4 py-3"
                data-testid={`outcome-${s.toLowerCase().replace(/\s/g, "-")}`}
              >
                <span className="w-1.5 h-1.5 rounded-full bg-brand-orange" />
                <span className="text-white text-[14px] font-semibold">{s}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="md:col-span-7 grid grid-cols-1 gap-4">
          {outcomes.map((t, i) => (
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="rounded-2xl brand-panel p-8 md:p-10 relative"
              data-testid={`testimonial-${i + 1}`}
            >
              <div className="absolute top-6 right-8 font-display text-white/25 text-[110px] leading-none select-none" style={{ fontWeight: 800 }}>
                &ldquo;
              </div>
              <p
                className="font-display text-white text-[22px] md:text-[26px] leading-[1.3] text-balance italic"
                style={{ fontWeight: 500 }}
              >
                {t.q}
              </p>
              <div className="mt-6 flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-gradient-to-br from-brand-purpleLight to-brand-orange" />
                <div>
                  <div className="text-white text-[14px] font-semibold">{t.a}</div>
                  <div className="font-display text-[10px] uppercase tracking-[0.28em] text-white/60 font-bold">
                    {t.role}
                  </div>
                </div>
              </div>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </Section>
  );
}
